import styled from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';
import Section from '$components/layout/Section';

export default styled(Section)`
  p {
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(24)};
    color: ${vars.quantumverse.reskinColors.neutral700};
    ${media.up('md')} {
      font-size: ${pxToRem(20)};
    }
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    &:last-child {
      font-size: ${pxToRem(14)};
      ${media.up('md')} {
        font-size: ${pxToRem(16)};
      }
    }
  }
  .link-1 {
    font-size: ${pxToRem(16)};
    ${media.up('md')} {
      font-size: ${pxToRem(20)};
    }
  }
`;
